/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import {
  Typography,
  makeStyles,
  Theme,
  createStyles,
  FormControl,
  InputAdornment,
  IconButton,
  Input,
  FormHelperText,
  Tooltip,
} from "@material-ui/core";
import { Field } from "formik";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockIcon from "@material-ui/icons/Lock";
import { EditComponentProps } from "material-table";
import {
  UserConfigDataRow,
  ConfigDataRowPassword,
} from "../../../../types/config";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    root: {
      fontSize: 13,
    },
    iconButton: {
      padding: "0.25rem",
    },
  })
);

/** ユーザーパスワード編集コンポーネント */
export function UserPasswordEditComponent(
  props: EditComponentProps<UserConfigDataRow>
) {
  const classes = useStyles();

  const { value, rowData, columnDef, onChange } = props;

  // 仮パスワードコンポーネント取得
  const getTemporaryPasswordComponent = () => {
    return (
      // eslint-disable-next-line react/destructuring-assignment
      <Field name={props.columnDef.field}>
        {(args: any) => {
          const { field, form } = args;
          const { name } = field;
          const { errors, touched, setFieldValue } = form;

          return (
            <>
              <FormControl>
                <Input
                  {...props}
                  {...field}
                  type={value.editVisible ? "text" : "password"}
                  className={classes.root}
                  placeholder={columnDef.title}
                  value={value.value}
                  error={touched[name] && errors[name]}
                  onChange={(e: any) => {
                    const newData: ConfigDataRowPassword = {
                      value: e.target.value, // 入力されたパスワードで上書きする
                      renderVisible: value.renderVisible,
                      editVisible: value.editVisible,
                      isTemporary: value.isTemporary,
                    };
                    // for MaterialTable
                    onChange(newData);
                    // for Fromik
                    setFieldValue(name, newData);
                  }}
                  size="small"
                  endAdornment={(
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className={classes.iconButton}
                        onClick={() => {
                          // データ更新
                          const newData: ConfigDataRowPassword = {
                            value: value.value,
                            renderVisible: value.renderVisible,
                            editVisible: !value.editVisible, // この値だけ反転させる
                            isTemporary: value.isTemporary,
                          };
                          // for MaterialTable
                          // eslint-disable-next-line react/prop-types
                          props.onChange(newData);
                          // for Formik
                          setFieldValue(name, newData);
                        }}
                        onMouseDown={(
                          event: React.MouseEvent<HTMLButtonElement>
                        ) => {
                          event.preventDefault();
                        }}
                      >
                        {value.editVisible ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  )}
                />
                {touched[name] && errors[name] && (
                  <FormHelperText error>
                    {touched[name] && errors[name]}
                  </FormHelperText>
                )}
              </FormControl>
            </>
          );
        }}
      </Field>
    );
  };

  // 本パスワードコンポーネント取得
  const getRegularPasswordComponent = () => {
    return (
      <Tooltip
        title="ユーザーによりパスワード変更済み"
        aria-label="ユーザーによりパスワード変更済み"
        enterDelay={1000}
        arrow
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography component="span" style={{ fontSize: 13 }}>
            ●●●●●●●●
          </Typography>
          <IconButton
            aria-label="toggle password visibility"
            className={classes.iconButton}
            disabled
          >
            <LockIcon />
          </IconButton>
        </div>
      </Tooltip>
    );
  };

  let component;
  if (rowData.password.isTemporary) {
    // 仮パスワードの場合
    // ・管理者がパスワードを編集できる
    component = getTemporaryPasswordComponent();
  } else {
    // 本パスワードの場合
    // ・本人しか変更できない（管理者が UserPasswordRenderComponent からリセット可能）
    component = getRegularPasswordComponent();
  }

  //--------------------
  // コンポーネント
  return component;
}
